// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"TableHeader_titleContainer__2dHC9","pTitle":"TableHeader_pTitle__2s1_P","rightP":"TableHeader_rightP__3Yqhx"};